import { useContext } from "react";
import { AuthenticationContext } from "../providers/authentication";

const useAuth = () => {
  const values = useContext(AuthenticationContext);
  return values;
};

export default useAuth;
